/* Built In Imports */
import { useContext } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import WrapLayout from '@Layout/WrapLayout';
import Breadcrum from '@components/Navigation/Breadcrum';
import CenterCommonUI from '@components/UI/Center';
import HeadComponent from '@components/Utility/HeadComponent';
import USChatBot from '@components/Utility/USChatBot';
import config from '@config';
import { AuthContext } from '@store/auth-context';
import { useRouter } from 'next/router';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import { fetchDetails, getLandingPaths } from 'services/centerService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
} from 'services/commonService';

/* Styles */

/**
 *
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Health Landing Page Data
 */
const ConsecratedSpaceCategory = ({ region, language, pageData }) => {
  const authContext = useContext(AuthContext);

  const router = useRouter();
  const centerUrl = router.asPath.includes('/special-process-offerings');

  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={''}
        url=""
        region={authContext.region}
        lang={language}
      />
      <Box
        as="section"
        className="page-wrap container-article"
        padding={{ base: '15px', md: '0' }}
      >
        <CenterCommonUI
          pageBody={pageData.body}
          region={authContext.region}
          lang={language}
        />
      </Box>
      {centerUrl && <USChatBot region={authContext.region}></USChatBot>}
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const centerLandingPaths = config.USE_LOCAL_URL
    ? [
        `/en/center/consecrated-spaces/adiyogi-abode-of-yoga/special-process-offerings`,
        `/en/center/consecrated-spaces/adiyogi-abode-of-yoga/special-process-offerings`,
      ]
    : await getLandingPaths('L3', '/center/consecrated-spaces/');
  return {
    paths: centerLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, spaces, category },
  req,
}) => {
  const language = region;
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale('', language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('', language),
    'iso_non_regional_menu'
  );
  const footerData = await fetchFooterData(
    getLocale('', language),
    'isofooter'
  );
  const pageData = await fetchDetails(
    '',
    language,
    `consecrated-spaces/${spaces}/${category}`,
    { preview, data: previewData }
  );

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: '',
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
    },
  };
};

export default ConsecratedSpaceCategory;
